/* eslint-disable */

//import Flickity from 'flickity/dist/flickity.pkgd';

//flickity
if($(".__module_slider_posts").length) {
  $(".__module_slider_posts").each(function() {
    var carouselID = $(this).find('.flickity').attr('id');
    carouselID = "#" + carouselID;
    //console.log(carouselID);

    //var elem = document.querySelector('.flickity');
    var elem = document.querySelector(carouselID);
    var flkty = new Flickity( elem, {
        accessibility: true,
        // enable keyboard navigation, pressing left & right keys
        adaptiveHeight: true,
        // set carousel height to the selected slide,
        cellSelector: '.flickity-cell',
        autoPlay: false,
        // advances to the next cell
        // if true, default is 3 seconds
        // or set time between advances in milliseconds
        // i.e. `autoPlay: 1000` will advance every 1 second
        cellAlign: 'center',
        // alignment of cells, 'center', 'left', or 'right'
        // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)
        //cellSelector: undefined,
        // specify selector for cell elements
        contain: false,
        // will contain cells to container
        // so no excess scroll at beginning or end
        // has no effect if wrapAround is enabled
        draggable: '>1',
        // enables dragging & flicking
        // if at least 2 cells
        dragThreshold: 3,
        // number of pixels a user must scroll horizontally to start dragging
        // increase to allow more room for vertical scroll for touch devices
        freeScroll: false,
        // enables content to be freely scrolled and flicked
        // without aligning cells
        friction: 0.2,
        // smaller number = easier to flick farther
        groupCells: 1,
        // group cells together in slides
        initialIndex: 0,
        // zero-based index of the initial selected cell
        lazyLoad: true,
        // enable lazy-loading images
        // set img data-flickity-lazyload="src.jpg"
        // set to number to load images adjacent cells
        percentPosition: true,
        // sets positioning in percent values, rather than pixels
        // Enable if items have percent widths
        // Disable if items have pixel widths, like images
        prevNextButtons: true,
        // creates and enables buttons to click to previous & next cells
        pageDots: false,
        // create and enable page dots
        resize: true,
        // listens to window resize events to adjust size & positions
        rightToLeft: false,
        // enables right-to-left layout
        setGallerySize: true,
        // sets the height of gallery
        // disable if gallery already has height set with CSS
        watchCSS: false,
        // watches the content of :after of the element
        // activates if #element:after { content: 'flickity' }
        wrapAround: true
        // at end of cells, wraps-around to first for infinite scrolling
    });

    // var elem2 = document.querySelector('.flickity-navigation');
    // var flktynav = new Flickity( elem2, {
    //   prevNextButtons: false,
    //   contain: true,
    //   pageDots: false
    // });



    $(window).load(function() {
        flkty.resize();
        //flktynav.resize();
    });
  });
}

var rotateArrayBackwards = function(arr, k) {
  let i = 0;
  while(i < k) {
    //nums.unshift(nums.pop());
    arr.push(arr.shift());
    i++;
  }
  return arr;
}

//Flickity lightbox
if($(".__module_image_gallery").length) {
  //$(".__galleryImg").click(function(){
  $(".imageGallery .galleryImgContainer .galleryImg").click(function() {

    var galleryID = $(this).parent().parent().attr('id');
    var clickedUrl = $(this).attr('id');

    //haetaan urlit id:stä
    var listOfUrls = [];
    var index = 0;
    var rotateAmount = 0;
    $('#' + galleryID + ' .galleryImg').each(function(){
      var urlFromID = $(this).attr('id');
      //pusketaan url arrayhin
      listOfUrls.push(urlFromID);
      //vastaako klikattu id tätä id:tä
      if(clickedUrl == urlFromID) {
        rotateAmount = index;
      }
      index++;
    });

    rotateArrayBackwards(listOfUrls, rotateAmount);

    createFlickityLightbox(listOfUrls);

  });

  //Lightbox poistuminen
  $(".lightbox-exit").click(function(){
    $('.lightbox-slider').remove();
    $(".lightbox-exit").hide();
  });
}

function createFlickityLightbox(listOfUrls) {
  //Lisätään lightbox bodyyn
  $('body').append('<div id=""><div class="lightbox-slider">' +
  '<div class="flickity-lightbox">' +
  '</div>' +
  '</div></div>');

  //Tehdään lightboxin sisältö
  var i;
  for(i = 0; i < listOfUrls.length; i++){
    $('.flickity-lightbox').append(
      '<div class="flickity-lightbox-cell" style="background: url(' + listOfUrls[i] + ')"></div>'
    );
  }

  //Luodaan flickity slider
  var elem = document.querySelector('.flickity-lightbox');
  var flkty_lightbox = new Flickity( elem, {
    accessibility: true,
    adaptiveHeight: true,
    cellSelector: '.flickity-lightbox-cell',
    autoPlay: false,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 3,
    freeScroll: false,
    friction: 0.2,
    groupCells: 1,
    initialIndex: 0,
    lazyLoad: true,
    percentPosition: true,
    prevNextButtons: true,
    pageDots: false,
    resize: true,
    rightToLeft: false,
    setGallerySize: true,
    watchCSS: false,
    wrapAround: true
  });

  flkty_lightbox.resize();

  //Sliderin napit ja kontrollit
  $(".lightbox-exit").show();

}

/* eslint-disable */

//flickity
if($(".__module_slider_posts").length) {
  $(".__module_slider_posts").each(function() {
    var carouselID = $(this).find('.flickity').attr('id');
    carouselID = "#" + carouselID;
    //console.log(carouselID);

    //var elem = document.querySelector('.flickity');
    var elem = document.querySelector(carouselID);
    var flkty = new Flickity( elem, {
      accessibility: true,
      // enable keyboard navigation, pressing left & right keys
      adaptiveHeight: true,
      // set carousel height to the selected slide,
      cellSelector: '.flickity-cell',
      autoPlay: false,
      // advances to the next cell
      // if true, default is 3 seconds
      // or set time between advances in milliseconds
      // i.e. `autoPlay: 1000` will advance every 1 second
      cellAlign: 'center',
      // alignment of cells, 'center', 'left', or 'right'
      // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)
      //cellSelector: undefined,
      // specify selector for cell elements
      contain: false,
      // will contain cells to container
      // so no excess scroll at beginning or end
      // has no effect if wrapAround is enabled
      draggable: '>1',
      // enables dragging & flicking
      // if at least 2 cells
      dragThreshold: 3,
      // number of pixels a user must scroll horizontally to start dragging
      // increase to allow more room for vertical scroll for touch devices
      freeScroll: false,
      // enables content to be freely scrolled and flicked
      // without aligning cells
      friction: 0.2,
      // smaller number = easier to flick farther
      groupCells: 1,
      // group cells together in slides
      initialIndex: 0,
      // zero-based index of the initial selected cell
      lazyLoad: true,
      // enable lazy-loading images
      // set img data-flickity-lazyload="src.jpg"
      // set to number to load images adjacent cells
      percentPosition: true,
      // sets positioning in percent values, rather than pixels
      // Enable if items have percent widths
      // Disable if items have pixel widths, like images
      prevNextButtons: true,
      // creates and enables buttons to click to previous & next cells
      pageDots: false,
      // create and enable page dots
      resize: true,
      // listens to window resize events to adjust size & positions
      rightToLeft: false,
      // enables right-to-left layout
      setGallerySize: true,
      // sets the height of gallery
      // disable if gallery already has height set with CSS
      watchCSS: false,
      // watches the content of :after of the element
      // activates if #element:after { content: 'flickity' }
      wrapAround: true
      // at end of cells, wraps-around to first for infinite scrolling
    });

    // var elem2 = document.querySelector('.flickity-navigation');
    // var flktynav = new Flickity( elem2, {
    //   prevNextButtons: false,
    //   contain: true,
    //   pageDots: false
    // });



    $(window).load(function() {
      flkty.resize();
      //flktynav.resize();
    });
  });
}

$(".imageGallery .galleryImgContainer .galleryImg").click(function() {

  var galleryID = $(this).parent().parent().attr('id');
  var clickedUrl = $(this).attr('id');

  //haetaan urlit id:stä
  var listOfUrls = [];
  $('#' + galleryID + ' .galleryImg').each(function(){
    var urlFromID = $(this).attr('id');
    listOfUrls.push(urlFromID);
  });

  listOfUrls = $.grep(listOfUrls, function(value) {
    return value != clickedUrl;
  });
  listOfUrls.unshift(clickedUrl);

  createFlickityLightbox(listOfUrls);

});

//Lightbox poistuminen
$(".lightbox-exit").click(function(){
  $('.lightbox-slider').remove();
  $(".lightbox-exit").hide();
});


//Product Flickitys
if($(".flickity-product").length) {
  var elem = document.querySelector('.flickity-product');
  var flkty = new Flickity( elem, {
    prevNextButtons: false,
    pageDots: false
  });

  var elem2 = document.querySelector('.flickity-navigation');
  var flktynav = new Flickity( elem2, {
    asNavFor: '.flickity-product',
    pageDots: false
  });

  $(window).load(function() {
    flkty.resize();
    flktynav.resize();
  });
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/autoload/flickitys.js